import React from 'react';
import { Route, Redirect, useLocation } from 'react-router-dom';
import { useApp } from '../../providers/UserProvider';

function ProtectedRoutes({ component: Component, ...rest }) {
  const location = useLocation();
  const { token } = useApp();

  return (
    <Route
      {...rest}
      render={props => {
        if (token) {
          return <Component {...props} />;
        }

        return (
          <Redirect
            to={{
              pathname: '/',
              state: {
                from: location,
              },
            }}
          />
        );
      }}
    />
  );
}

export default ProtectedRoutes;
